import { differenceInDays } from "date-fns";

export function formatGoalEta(
  eta?: { years: number; months: number } | null
): string | undefined {
  if (!eta) return undefined;

  const parts: string[] = [];
  if (eta.years) parts.push(`${eta.years}y`);
  if (eta.months) parts.push(`${eta.months}m`);
  return parts.length ? parts.join(" ") : undefined;
}

export function formatDistanceInDays(date: Date, prefix: string = ""): string {
  const days = differenceInDays(date, new Date());
  if (days < 0) {
    return "Past due";
  }
  if (days < 30) {
    return `${prefix} ${days} day${days !== 1 ? "s" : ""}`;
  }
  const months = Math.floor(days / 30);
  if (months < 12) {
    return `${prefix} ${months} month${months !== 1 ? "s" : ""}`;
  }
  let years = Math.floor(days / 365);
  let remainingMonths = Math.floor((days % 365) / 30);
  // Handle edge case where remaining days equal 12+ months
  if (remainingMonths >= 12) {
    years += 1;
    remainingMonths = 0;
  }
  if (remainingMonths > 0) {
    return `${prefix} ${years} year${years !== 1 ? "s" : ""} ${remainingMonths} month${remainingMonths !== 1 ? "s" : ""}`;
  }
  return `${prefix} ${years} year${years !== 1 ? "s" : ""}`;
}
